import axios from "axios";

// Cliente para las rutas PÚBLICAS (formulario de leads, guías): sin cookies,
// sin header de tenant -- estas páginas no tienen sesión ni tenant activo,
// el backend resuelve todo a partir del código del tracking_link.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const publicApi = axios.create({ baseURL: API });

export default publicApi;
